import React from 'react';
import { useBrand } from '../../contexts/BrandContext';

// Simple branded text component
export default function BrandedText({ className = "", children, fallback = null }) {
  const { brand } = useBrand();
  
  // If children provided, use that. Otherwise use brand name
  const text = children || brand.name;
  
  return (
    <span className={className}>
      {text}
    </span>
  );
}

// Specific branded text components
export function BrandName({ className = "" }) {
  const { brand } = useBrand();
  return <span className={className}>{brand.name}</span>;
}

export function BrandTagline({ className = "" }) {
  const { brand } = useBrand();
  return <span className={className}>{brand.tagline}</span>;
}

export function BrandDescription({ className = "" }) {
  const { brand } = useBrand();
  return <span className={className}>{brand.description}</span>;
}

// Support email with proper branding
export function BrandSupportEmail({ className = "", showLabel = true }) {
  const { brand } = useBrand();
  
  return (
    <a 
      href={`mailto:${brand.supportEmail}`}
      className={`text-primary-600 hover:text-primary-700 ${className}`}
    >
      {showLabel ? `Contact ${brand.name} Support` : brand.supportEmail}
    </a>
  );
}